import { ICashRegister } from '@/models/financialSettings.model';
import { CashRegisterFormFields, TCashRegisterFormValues } from './types';

export const getInitialCashRegisterValues = (item?: ICashRegister | null): Partial<TCashRegisterFormValues> => {
  if (!item) {
    return {
      [CashRegisterFormFields.LEGAL_TYPE]: 'fop',
      [CashRegisterFormFields.IS_VIRTUAL]: true,
      [CashRegisterFormFields.IS_ACTIVE]: true,
    };
  }

  return {
    [CashRegisterFormFields.NAME]: item.name,
    [CashRegisterFormFields.NUMBER]: item.number ?? undefined,
    [CashRegisterFormFields.FISCAL_NUMBER]: item.fiscal_number ?? undefined,
    [CashRegisterFormFields.LEGAL_TYPE]: item.legal_type,
    [CashRegisterFormFields.IS_VIRTUAL]: item.is_virtual,
    [CashRegisterFormFields.IS_ACTIVE]: item.is_active,
    [CashRegisterFormFields.FISCAL_DEPARTMENT]: item.fiscal_department ?? undefined,
    [CashRegisterFormFields.CASHIER_NAME]: item.cashier?.name ?? undefined,
    [CashRegisterFormFields.CASHIER_LOGIN]: item.cashier?.login ?? undefined,
    // Secrets are write-only and never prefilled.
  };
};
